import React from 'react';
import { TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Autocomplete } from '@material-ui/lab';
import PropTypes from 'prop-types';

import { handleAutocompleteChange, handleTextFieldChange } from '../functions/InputHandlers';

import { getAccountTypeOptions, nameLabel } from './Autocomplete/Library';
import Checkbox from './Checkbox';
import DialogTemplate from './DialogTemplate';

class FilterChartOfAccountsDialog extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { filter: props.filter };
  }

  updateFilter = async (event) => {
    event.preventDefault();
    const { filter } = this.state;
    const { updateFilter, closeDialog } = this.props;

    filter.page = 0;
    updateFilter(filter);

    closeDialog();
  };

  render() {
    const { closeDialog } = this.props;
    const { filter } = this.state;

    return (
      <DialogTemplate
        open
        scroll="body"
        maxWidth="sm"
        fullWidth
        onClose={closeDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="filterChartOfAccountsDialog"
      >
        <form onSubmit={this.updateFilter}>
          <DialogTitle id="alert-dialog-title">Filter Accounts</DialogTitle>
          <DialogContent>
            <TextField
              label="Account Name"
              margin="dense"
              fullWidth
              InputProps={{
                value: filter.accountName,
                name: 'nested_filter_accountName',
                onChange: handleTextFieldChange(this),
              }}
            />
            <Autocomplete
              options={getAccountTypeOptions}
              getOptionLabel={nameLabel}
              value={filter.accountType}
              onChange={handleAutocompleteChange('nested_filter_accountType', this)}
              getOptionSelected={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField {...params} margin="dense" label="Account Type" placeholder="Type to Search" fullWidth />
              )}
            />
            <Checkbox
              label="Show inactive accounts"
              checked={filter.hideInactive}
              onChange={() => this.setState({ filter: { ...filter, hideInactive: !filter.hideInactive } })}
            />
            <Checkbox
              label="Hide System Defaults"
              checked={filter.hideDefaults}
              onChange={() => this.setState({ filter: { ...filter, hideDefaults: !filter.hideDefaults } })}
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit" variant="contained" color="primary" disableElevation>
              Update Filter
            </Button>
            <Button onClick={closeDialog} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </DialogTemplate>
    );
  }
}

FilterChartOfAccountsDialog.propTypes = {
  filter: PropTypes.objectOf(PropTypes.any).isRequired,
  dialogOpen: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
};

export default FilterChartOfAccountsDialog;
